const Labels = {
	OPEN: "open",
	REOPENED: "reopened",
	PENDING: "pending",
	SUBMITTED: "submitted",
	CLOSED: "closed",
	PERSISTENCE: "persistence",
};

const labelsList = Object.values(Labels);

const autoClosed = "Auto Closed";
const autoVerified = "Auto verified";
const PersistenceClosed = "closed by persistence";
const noAnalysts = "Supervisor";

const SOLUTIONS = {
	mnl: "mnl",
	wire: "wire",
	ach: "ach",
	pkyc: "pkyc",
	tf360: "tf360",
	tf799: "tf799",
	pi_a: "314a",
};

const ACH_SOLUTION_MODES = {
	SANCTIONS_ONLY: "SANCTIONS_ONLY",
	VOP_ONLY: "VOP_ONLY",
	SANCTIONS_AND_VOP: "SANCTIONS_AND_VOP",
};

const PKYC_TYPES = {
	customers: "customer",
	employees: "employee",
	vendors: "vendor",
};

const STATUSES = {
	ALERTED: "alerted",
	BLOCKED: "blocked",
	FLAGGED: "flagged",
	VERIFIED: "verified",
	SEIZED: "seized",
};

// VOP decision vocabulary. Distinct from STATUSES because the questions they
// answer are different (sanctions: "is this name sanctioned?", VOP: "do we
// release this payment despite the name mismatch?"). Mirrors api's vopStatuses
// in services/api/src/constants/index.js.
const VOP_STATUSES = {
	MISMATCH: "mismatch",
	BLOCKED: "blocked",
	VALIDATED: "validated",
};

const RUN_TIMINGS = ["monthly", "daily", "weekly", "custom"];
const WEEKEND_TYPES = [
	"first weekend",
	"last weekend",
	"1st day",
	"day after upload",
	"first sunday after 10th",
];

const DASH_DASH_EMPTY_VALUE = "---";

const GRANULARITIES = [
	{ title: "Daily", value: "daily" },
	{ title: "Weekly", value: "weekly" },
	{ title: "Monthly", value: "monthly" },
];

const OUTCOME_LABELS = {
	true_positive: "Verified",
	escalated: "Flagged",
	auto_closed: "Auto Closed",
	open: "Open",
	pending: "Pending",
};

const FINAL_STATUS_OPTIONS = [
	{ title: "Open", value: "open" },
	{ title: "Closed", value: "closed" },
	{ title: "Pending", value: "pending" },
	{ title: "Submitted", value: "submitted" },
	{ title: "Reopened", value: "reopened" },
];

const SOLUTION_OPTIONS = [
	{ title: "Wire", value: "wire" },
	{ title: "Wire REST", value: "wire_rest" },
	{ title: "ACH", value: "ach" },
	{ title: "PKYC", value: "pkyc" },
	{ title: "TF360", value: "tf360" },
	{ title: "TF799", value: "tf799" },
	{ title: "Manual", value: "mnl" },
];

export {
	ACH_SOLUTION_MODES,
	autoClosed,
	autoVerified,
	DASH_DASH_EMPTY_VALUE,
	FINAL_STATUS_OPTIONS,
	GRANULARITIES,
	Labels,
	labelsList,
	noAnalysts,
	OUTCOME_LABELS,
	PersistenceClosed,
	PKYC_TYPES,
	RUN_TIMINGS,
	SOLUTION_OPTIONS,
	SOLUTIONS,
	STATUSES,
	VOP_STATUSES,
	WEEKEND_TYPES,
};
